import {
  PlanEditorController
} from './plan-editor.component';

export class PlanEditorModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;

  }

  open() {
    const updateModalSize = () => {
      $('.plan-body').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.list-head').outerHeight() -
        $('.modal-footer').outerHeight()));
      // $('.toolbar-color>div').innerWidth(document.querySelector('.list-body>div').clientWidth);
    };


    this.modalInstance = this.$modal.open({
      template: require('./plan-editor.component.html'),
      controller: PlanEditorController,
      resolve: {
      },
      windowClass: 'sc-plan-editor-modal',
    });
    this.modalInstance.opened
      .then(() => {
        this.$timeout(() => {
          updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return this.modalInstance.result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/plan-editor/plan-editor-modal.service.js